import React, { forwardRef } from 'react';

// Use Kendo Slider directly, styles will be applied globally via theme.scss
import { Slider as KendoSlider, SliderProps as KendoSliderProps, SliderChangeEvent } from '@progress/kendo-react-inputs';

// Define Props for the core UI Slider - Extend Kendo props
export interface SliderProps extends Omit<KendoSliderProps, 'style'> {
  // Omit style to allow custom style prop
  label?: string; // Optional label for accessibility
  width?: string | number; // Optional width prop
  style?: React.CSSProperties; // Add style prop back
  // Remove container props as we are not using a wrapper anymore
  // containerClassName?: string;
  // containerStyle?: React.CSSProperties;
}

// Export the Slider component - Now a simpler wrapper around KendoSlider
export const Slider = forwardRef<HTMLSpanElement, SliderProps>(
  (
    {
      label,
      width,
      value,
      min = 1,
      max = 8,
      onChange,
      style, // Capture existing style prop
      ...rest // Pass remaining Kendo props directly
    },
    ref,
  ) => {
    // Combine the width prop with any existing style prop
    const combinedStyle: React.CSSProperties = {
      ...(width && { width }), // Add width if provided
      ...style, // Spread existing style prop
    };

    return (
      <KendoSlider
        ref={ref}
        min={min}
        max={max}
        value={value}
        onChange={onChange}
        aria-label={rest.ariaLabel || label || 'Slider'}
        style={combinedStyle} // Apply combined style
        {...rest}
      />
    );
  },
);

Slider.displayName = 'Slider';

// Re-export the event type for convenience
export type { SliderChangeEvent };
